import { Component, ViewChild } from '@angular/core';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-leave-policies',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule,LoaderComponent],
  templateUrl: './leave-policies.component.html',
  styleUrl: './leave-policies.component.scss'
})
export class LeavePoliciesComponent {
  isDisabled: boolean = false;
  LeaveData: any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private leave: LeaveService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
    private toast : ToastService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESSLeavePolicySelectGet();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESSLeavePolicySelectGet() {
    this.isDisabled = true;
    this.leave.ESSLeavePolicySelectGet({ SelectType: 1, ESS_ShiftRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        // element.WebESSApplicability2 = response.Table3.filter((e: any) => e.WebESSApplicabilityId1 == element.WebESSApplicabilityId1)[0]?.ApplicabilityName
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table1.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'LeavePolicyMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.LeaveData = data;
        if(this.LeaveData.length > 0 ){
          this.download.exportToExcel(this.LeaveData, "LeaveRulePolicies_data");
           this.isDisabled = false
        }
        else{
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      
      });
  }
}